import { render, staticRenderFns } from "./airport.vue?vue&type=template&id=24c2c5de&scoped=true&"
import script from "./airport.vue?vue&type=script&lang=js&"
export * from "./airport.vue?vue&type=script&lang=js&"
import style0 from "./airport.vue?vue&type=style&index=0&id=24c2c5de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2c5de",
  null
  
)

export default component.exports